module.exports = __webpack_public_path__ + "static/media/caregiver_slider_phone3.04e68378.png";